import { Card, Group, Loader, Stack, Text } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';
import type { ReactNode } from 'react';

interface Props {
  title: string;
  isLoading: boolean;
  isError: boolean;
  partial?: boolean;
  children?: ReactNode;
}

export function MetricCard({ title, isLoading, isError, partial = false, children }: Props) {
  return (
    <Card shadow="sm" padding="lg" h="100%">
      <Stack gap="xs">
        <Group justify="space-between">
          <Text size="sm" c="dimmed" tt="uppercase">
            {title}
          </Text>
          {partial && <IconAlertTriangle size={16} color="orange" aria-label="partial data" />}
        </Group>
        {isLoading ? (
          <Loader size="sm" />
        ) : isError ? (
          <Text c="red">Stats unavailable</Text>
        ) : (
          children
        )}
      </Stack>
    </Card>
  );
}
